import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { AuthShell } from "./AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  if (!token) return (
    <AuthShell title={t("reset_password")}>
      <p className="text-slate-400 text-sm">Invalid or missing reset token. <Link to="/forgot-password" className="text-brand-cyan">Request a new one</Link>.</p>
    </AuthShell>
  );

  return (
    <AuthShell title={t("reset_password")} subtitle="Choose a new password">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <div>
          <Label className="text-slate-300">New {t("password")}</Label>
          <Input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password" className="mt-1.5 bg-white/5 border-white/10" />
        </div>
        <Button type="submit" disabled={loading} data-testid="reset-submit" className="w-full gradient-brand text-brand-navy font-semibold">{loading ? t("loading") : t("reset_password")}</Button>
      </form>
    </AuthShell>
  );
}
